<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div v-if="needCheckConfirmCode" class="confirm-panel">
                    <checkemailconfirmcode :emailAddress="inputForm.primaryOwnerEmail.value" @check-successful="handleOnConfirmComplete()"></checkemailconfirmcode>
                    <div style="padding: 20px;text-align:center">
                        <el-button class="dialog-ok-button" @click="needCheckConfirmCode=false" v-t="'message.button_close'"></el-button>
                    </div>
                </div>
                <div v-else>
                    <div class="dialog-title" v-t="'message.title_modify_tenant_information'">
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-body-small">
                        <el-form :model="inputForm" :rules="validationRule" ref="inputForm" label-width="150px" >
                            <div class="dialog-form-item">
                                <el-form-item prop="corporateName" ref="corporateName">
                                    <div slot="label" class="form-item-label">
                                        <span v-t="'message.item_tenant_company'"></span>
                                        <span class="required" v-t="'message.item_required'"></span>
                                    </div>
                                    <el-input id="corporateName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.corporateName.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="InputCheckAll()"/>
                                </el-form-item>
                                <el-form-item prop="departmentName" ref="departmentName">
                                    <div slot="label" class="form-item-label">
                                        <span v-t="'message.item_tenant_department'"></span>
                                        <span class="required" v-t="'message.item_required'"></span>
                                    </div>
                                    <el-input id="departmentName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.departmentName.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="InputCheckAll()"/>
                                </el-form-item>
                                <el-form-item prop="primaryOwnerName" ref="primaryOwnerName">
                                    <div slot="label" class="form-item-label">
                                        <span v-t="'message.item_tenant_contact'"></span>
                                        <span class="required" v-t="'message.item_required'"></span>
                                    </div>
                                    <el-input id="primaryOwnerName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.primaryOwnerName.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="InputCheckAll()"/>
                                </el-form-item>
                                <el-form-item prop="primaryOwnerEmail" ref="primaryOwnerEmail">
                                    <div slot="label" class="form-item-label">
                                        <span v-t="'message.item_tenant_email'"></span>
                                        <span class="required" v-t="'message.item_required'"></span>
                                    </div>
                                    <el-input id="primaryOwnerEmail" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.primaryOwnerEmail.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="InputCheckAll()"/>
                                </el-form-item>
                                <el-form-item prop="phoneNumber" ref="phoneNumber">
                                    <div slot="label" class="form-item-label">
                                        <span v-t="'message.item_tenant_phone'"></span>
                                        <span class="required" v-t="'message.item_required'"></span>
                                        </div>
                                    <el-input id="phoneNumber" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.phoneNumber.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="InputCheckAll()"/>
                                </el-form-item>
                                <table style="border-spacing: 0px;">
                                    <tr>
                                        <td width="45%">
                                            <div class="dialog-form-item">
                                            <el-form-item prop="zip" ref="zip" class="el-form-half-item">
                                                <div slot="label" class="form-item-label">
                                                    <span v-t="'message.item_tenant_zip'"></span>
                                                </div>
                                                <el-input id="zip" class="el-input-half-item" type="text" v-model="inputForm.zip.value"
                                                    @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                                    clearable @clear="InputCheckAll()"/>
                                            </el-form-item>
                                            </div>
                                        </td>
                                        <td width="10%">&nbsp;</td>
                                        <td width="45%">
                                            <div class="dialog-form-item">
                                            <el-form-item prop="pref" ref="pref"  class="el-form-half-item" label-width="70px">
                                                <div slot="label" class="form-item-label">
                                                    <span v-t="'message.item_tenant_pref'"></span>
                                                </div>
                                                <el-select v-model="inputForm.pref.value" style="margin-left=15px" @change="handleChangePref()">
                                                    <el-option v-for="pref in prefList" :key="pref" :label="pref" :value="pref"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td width="45%">
                                            <div class="dialog-form-item">
                                            <el-form-item prop="city" ref="city"  class="el-form-half-item">
                                                <div slot="label" class="form-item-label">
                                                    <span v-t="'message.item_tenant_city'"></span>
                                                </div>
                                                <el-input id="city" class="el-input-half-item" type="text" v-model="inputForm.city.value"
                                                    @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                                    clearable @clear="InputCheckAll()"/>
                                            </el-form-item>
                                            </div>
                                        </td>
                                        <td width="10%">&nbsp;</td>
                                        <td width="45%">
                                            <div class="dialog-form-item">
                                            <el-form-item prop="town" ref="town"  class="el-form-half-item" label-width="70px">
                                                <div slot="label" class="form-item-label" >
                                                    <span v-t="'message.item_tenant_town'"></span>
                                                </div>
                                                <el-input id="town" class="el-input-half-item" size="large" type="text" v-model="inputForm.town.value"
                                                    @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                                    clearable @clear="InputCheckAll()"/>
                                            </el-form-item>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                                <el-form-item prop="street" ref="street">
                                    <div slot="label" class="form-item-label">
                                        <span v-t="'message.item_tenant_street'"></span>
                                    </div>
                                    <el-input id="street" class="el-inputitem" size="large" type="text" v-model="inputForm.street.value"
                                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                        clearable @clear="InputCheckAll()"/>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <div v-if="needCheckConfirmCode">
                            <el-button class="dialog-cancel-button" @click="needCheckConfirmCode=false" v-t="'message.button_back'"></el-button>
                            <el-button class="dialog-ok-button" :disabled="disableConfirmButton" @click="$emit('save',inputForm)" v-t="'message.button_save'"></el-button>
                        </div>
                        <div v-else>
                            <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                            <el-button  class="dialog-ok-button" @click="saveAccountInfo" :disabled="this.disableButton" v-t="'message.button_save'"></el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import characterCheck from './charactercheck.js';
import commonValidate from './common-validate.js';
import CheckEmailConfirmCode from './CheckEmailConfirmCode.vue';

export default {
    data () {
        return {
            needCheckConfirmCode: false,
            disableConfirmButton: true,
            disableButton: true,
            inputNumber: [ "", "", "", "", "", ""],
            prefList: [],
            inputForm: {
                corporateName:      { validationRule: "reqDisplayName", valid: true, value: null,   isComposing: false },
                departmentName:     { validationRule: "reqDisplayName", valid: true, value: null,   isComposing: false },
                primaryOwnerName:   { validationRule: "reqDisplayName", valid: true, value: null,   isComposing: false },
                primaryOwnerEmail:  { validationRule: "emailAddress",   valid: true, value: null,   isComposing: false },
                phoneNumber:        { validationRule: "phoneNumber",    valid: true, value: null,   isComposing: false },
                zip:                { validationRule: "zip",            valid: true, value: null,   isComposing: false },
                pref:               { validationRule: "addressPref",    valid: true, value: null,   isComposing: false },
                city:               { validationRule: "address1",       valid: true, value: null,   isComposing: false },
                town:               { validationRule: "address1",       valid: true, value: null,   isComposing: false },
                street:             { validationRule: "address2",       valid: true, value: null,   isComposing: false },
            },
        };
    },
    methods: {
        handleOnConfirmComplete() {
            // confirm code completion event.
            this.needCheckConfirmCode = false;
            this.$emit('save',this.inputForm);
        },
        setButtonStatus: function() {
            for (let targetId in this.inputForm) {
                if (!this.inputForm[targetId].valid) {
                    this.disableButton = true;
                    return;
                }
            }
            this.disableButton = false;
        },
        saveAccountInfo() {
            let self = this;
            let countryCode = "";
            if (this.$i18n.locale == "ja") {
                countryCode = "JPN";
            }

            if (self.tenant.primaryOwner != self.inputForm.primaryOwnerEmail.value) {
                const loadingScreen = this.$loading({
                        lock: true ,
                        text: 'processing ...' ,
                        spinner: 'el-icon-loading' ,
                        background: 'rgba(0, 0, 0, 0.7)'
                });

                // send confirm code to new email address.
                server.postNoError('/sendconfirmationcode', { email: this.inputForm.primaryOwnerEmail.value, countryCode:countryCode })
                .then((res) => {
                    loadingScreen.close();
                    switch(res.data.status) {
                        case 0:
                            self.needCheckConfirmCode = true;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","saveAccountInfo").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    loadingScreen.close();
                    commonUtil.putExceptionErrorMessage(self, "saveAccountInfo", error);
                });
                return;
            } else {
                self.$emit('save',self.inputForm);
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult;
            if (eventTargetId == "phoneNumber") {
                validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value, this.tenant.countryCode);
            } else {
                validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            }
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        handleChangePref() {
            this.$refs["pref"].clearValidate();
            this.inputForm.pref.valid = true;
            this.setButtonStatus();
        }
    },
    created: function() {
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', '../js/yubinbango-core.js')
        document.head.appendChild(externalScript)

        this.inputForm.corporateName.value = this.tenant.displayName;
        this.inputForm.departmentName.value = this.tenant.departmentName;
        this.inputForm.primaryOwnerName.value = this.tenant.primaryOwnerName;
        this.inputForm.primaryOwnerEmail.value = this.tenant.primaryOwner;
        this.inputForm.phoneNumber.value = this.tenant.phoneNumber;
        this.inputForm.zip.value = this.tenant.zip;
        this.inputForm.pref.value = this.tenant.addressPref;
        this.inputForm.city.value = this.tenant.addressCity;
        this.inputForm.town.value = this.tenant.addressTown;
        this.inputForm.street.value = this.tenant.addressStreet;
        this.prefList = commonUtil.getPrefList();
    },
    mounted: function() {
    },
    watch: {
        'inputForm.zip.value': function(zip) {
            if (this.prefList == null) {
                return;
            }
            if (typeof(YubinBango) === "undefined") {
                return;
            }
            let self = this
            if (zip.length < 7) {
                self.inputForm.pref.value = "";
                self.inputForm.city.value = "";
                self.inputForm.town.value = "";
                self.inputForm.street.value = "";

                self.inputCheck("pref");
                self.inputCheck("city");
                self.inputCheck("town");
                self.inputCheck("street");
                return;
            }
            new YubinBango.Core(zip, function(addr) {
                self.inputForm.pref.value = addr.pref;
                self.inputForm.city.value = addr.city;
                self.inputForm.town.value = addr.town;
                self.inputForm.street.value = addr.street;

                self.inputCheck("pref");
                self.inputCheck("city");
                self.inputCheck("town");
                self.inputCheck("street");
            })
        },
    },
    components: {
        checkemailconfirmcode: CheckEmailConfirmCode
    },
    props: ['tenant']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.confirm-panel {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #ecf1fa;
}
.el-input-half-item {
    width: 100px;
}
.el-input.el-input-half-item >>> .el-form-item__error {
    margin-left: 0px;
}
.el-input-half-item >>> .el-form-item__error {
    margin-left: 0px;
}
.el-input-half-item .el-input .el-input--large >>> .el-form-item__error {
    margin-left: 0px;
}
.el-input-half-item >>> .el-input__inner {
    padding-left: 10px;
}
.el-input-half-item >>> .el-input {
    width: 100px;
}
.dialog-form-item > .el-form-item.is-success {
    margin-bottom: 22px;;
}
.el-form-item.el-form-half-item {
    margin-bottom: 30px;
}

.form-item-label {
    text-align: left;
}
.form-button-field {
    padding-top: 10px;
    padding-bottom: 20px;
    text-align: center;
}

.check-code {
    text-align: center;
    padding-top: 30px;
}
.check-number {
    width: 45px;
    padding-left: 15px;
    font-size: 20px;
}
.check-code >>> .el-input__inner {
    padding-left: 15px;
}

.confirm-message {
    padding-top: 40px;
    text-align: center;
}
.confirm-error {
    padding-bottom: 15px;
    height: 20px;
    color: #d55169;
}

</style>
